module.exports = __webpack_public_path__ + "img/bowling-solitaire.db5063c6.png";